import PropTypes from "prop-types";
import Image from "next/image";

import { Grid, Typography, Box } from "@/components/core";
import { CURRENCY_CODE_TO_FLAG_PATH } from "@/utils/constants/common";

export function SelectOptions({ currency, ...params }: any) {
  return (
    <Box {...params}>
      <Grid direction="row" justifyContent="space-between" spacing={4}>
        <Grid.Item>
          <Grid spacing={1}>
            <Grid.Item>
              <Image
                alt={currency.label}
                src={CURRENCY_CODE_TO_FLAG_PATH[currency.isoCode]}
                width={40}
                loading="lazy"
              />
            </Grid.Item>
            <Grid.Item>
              <Typography>{currency.isoCode}</Typography>
            </Grid.Item>
          </Grid>
        </Grid.Item>
        <Grid.Item>
          <Typography variant="caption">{currency.label}</Typography>
        </Grid.Item>
      </Grid>
    </Box>
  );
}

SelectOptions.propTypes = {
  currency: PropTypes.shape({
    isoCode: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.string,
  }),
};
